<template>
  <div class="mainContainer">
    <ToolWrap :isIndex="true" v-show="isSmartCityApp" :title="title" />
    <div class="topBg"></div>
    <div class="ruleContent">
      <div class="ruleDetail">
        <div class="ruleTitle">投票规则</div>
        <div></div>
        <div class="mt-10"></div>
        <div>1.投票时间即日起至12月16日17时；</div>
        <div>2.请在20名候选人中选10人投票，少于或多于10人将视为无效；</div>
        <div>3.每人每天只能参与投票一次。</div>
        <!-- <div>4.南太湖号活动期间每人每天可投1次。</div>
        <div class="mt-10"></div>
        <div>投票活动监督电话：0572-2399967</div>
        <div>监督邮箱：48240737@qq.com</div> -->
      </div>
    </div>
    <div class="mainContent">
      <div class="topInfoBox flexBetween">
        <div class="flexColumnCenter topInfo">
          <div>{{ mainData.programCount }}</div>
          <div>候选人</div>
        </div>
        <div class="flexColumnCenter topInfo">
          <div>{{ mainData.assistCount }}</div>
          <div>投票数</div>
        </div>
        <div class="flexColumnCenter topInfo">
          <div>{{ mainData.visitCount }}</div>
          <div>浏览次数</div>
        </div>
      </div>
      <div class="programList">
        <div class="searchContent flexBetween" v-show="targetTab === 0">
          <input
            type="text"
            placeholder="请输入编号进行查询"
            v-model="searchText"
          />
          <div class="searchBtn" @click="searchProgram(1)">搜索</div>
          <div class="searchIcon"></div>
        </div>
        <div class="programTabs flexBetween">
          <div :class="targetTab === 0 ? 'actTab' : ''" @click="switchTab(0)">
            候选人
          </div>
          <div :class="targetTab === 1 ? 'actTab' : ''" @click="switchTab(1)">
            排行榜
          </div>
        </div>
        <!-- 分类 -->
        <!-- <van-tabs
          v-model="activeTab"
          background="transparent"
          color="transparent"
          title-active-color="@mainColor"
          v-show="targetTab === 0"
        >
          <van-tab
            :title="item"
            v-for="(item, index) in typeList"
            :key="index"
          ></van-tab>
        </van-tabs> -->

        <div class="list" v-if="targetTab === 0">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            :immediate-check="true"
          >
            <div class="flexAround" style="flex-wrap: wrap">
              <div
                class="item"
                v-for="(item, index) in list"
                :key="`${item.id}-${index}`"
              >
                <div class="img-wrap">
                  <img v-lazy="item.url" @click.stop="onItemClick(item)" />
                </div>
                <div class="info">
                  <div class="indexContainer">{{ item.title }}</div>
                  <!-- <div class="maxHeight1">
                    <div class="names">{{ item.realName }}</div>
                  </div> -->
                  <div class="maxHeight flexBetween">
                    <div style="flex: 1">
                      <div class="title">{{ item.voteNum }}票</div>
                      <!-- <div class="names">{{ item.real_name }}</div> -->
                    </div>

                    <div class="checkIcon">
                      <van-checkbox
                        v-show="assistedList.length == 0"
                        v-model="item.checked"
                        checked-color="#ff4e27"
                        :max="10"
                        @change="(...params) => onCheckChange(params, item)"
                      >
                      </van-checkbox>
                    </div>
                    <!-- {{ item.title }} -->
                    <!-- <div class="name">{{ item.names }}</div> -->
                  </div>
                  <!-- <div class="name fromGroup">{{ item.voteNum }}票</div> -->
                  <!-- <div class="name fromGroup">{{ item.names }}</div> -->
                  <!-- <div class="flexBetween">
                    <div></div>
                    <div
                      class="helpBtn"
                      :class="returnIfAssisted(item.id) ? 'assistedBtn' : ''"
                      @click="toVote(item.id)"
                      style="opacity: 0"
                    >
                      {{ returnIfAssisted(item.id) ? "已投票" : "投票" }}
                    </div>
                  </div> -->
                </div>
                <div class="newIndexFlag">
                  {{ item.number }}
                </div>
                <!-- {{ item.number }} {{ item.voteNum }}票 -->
                <!-- <div class="indexFlag">{{ item.id }}</div> -->
              </div>
              <div
                style="width: 50%"
                class="emptyItem"
                v-for="(item, index) in 2 - (list.length % 2)"
                v-show="list.length % 2 > 0"
                :key="index"
              ></div>
            </div>
          </van-list>
          <!-- <div class="pos"></div> -->
        </div>
        <div class="rankList" v-else>
          <div v-for="(type, i) in typeList" :key="i">
            <!-- <div class="typeBar">- {{ type }} -</div> -->
            <div
              class="rankItem flexBetween"
              v-for="(item, index) in rankList[type]"
              :key="index"
            >
              <div class="rankIndexFlag">{{ index + 1 }}</div>
              <div class="rankItemTitle">{{ item.title }}</div>
              <!-- <div class="rankItemTitle">{{ returnTypeStr(item.type) }}</div> -->
              <div class="voteNum">{{ item.voteNum }}票</div>
              <!-- <div class="number">{{ item.number }}</div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-dialog
      v-model="showDialog"
      title="请输入验证码"
      :before-close="beforeClose"
      show-cancel-button
    >
      <div class="verify flexBetween">
        <van-field
          style="width: 70%"
          v-model="code"
          placeholder="在此输入验证码"
        ></van-field>
        <img :src="codeUrl" alt="" @click="onUpdateCode" />
      </div>
    </van-dialog>
    <!-- <div class="addBtn" @click="jumpTo"></div> -->
    <div
      v-show="targetTab === 0"
      :class="assistedList.length > 0 ? 'assistedBtn' : ''"
    >
      <div
        class="submitBtn flexCenter"
        @click="vote"
        :class="scrollTop > 800 ? 'showBtn' : ''"
      >
        <div class="voteText">
          {{ assistedList.length > 0 ? "已" : "" }}投票
        </div>
        <div class="selectedContainer">
          已选择：{{ votedNum }}/{{ limitNum }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";
import axios from "axios";
import {
  getWorksList,
  worksVote,
  getVoteRankList,
  getMainData,
  userAccess,
  searchProgram,
  getAssistedPrograms,
  getVoteNum,
  getOpenId,
  programVote,
  getWxAssistedPrograms,
  wxUserAccess,
} from "@/api/childrenVote";
import ToolWrap from "../components/ToolWrap/index.vue";
import { setItem, getItem } from "../utils/storage";
import { setLocalStorage, getLocalStorage, getQueryString } from "@/utils/util";
export default {
  name: "home",
  data() {
    return {
      targetTab: 0,
      list: [],
      showDialog: false,
      showCount: false,
      active: 0,
      result: [],
      rankList: [],
      codeUrl: "",
      code: "",
      isIos: false,
      timestamp: "",
      nonceStr: "",
      signature: "",
      loading: false,
      finished: false,
      rankLoading: false,
      rankFinished: false,
      pageData: {
        page: 1,
        pageSize: 10,
      },
      rankListPageData: {
        page: 1,
        pageSize: 100,
      },
      mainData: {
        assistCount: 0,
        programCount: 6,
        visitCount: 2,
      },
      targetId: null,
      searchText: "",
      pageFlag: 0,
      assistedList: [],
      activeTab: 0,
      typeList: ["你的新年日历"],
      isSmartCityApp: false,
      title: `2022年“最美湖州人”候选人公示投票`,
      checkboxResult: [],
      scrollTop: 0,
      wxCode: "",
      appId: "wxc0ae0375c6f4a068", //爱湖州
      openId: "",
      jumpUrl: "http://share.plus.hugd.com/app/jump/2022/zmhzrVote",
      limitNum: 10,
    };
  },
  components: { ToolWrap },
  methods: {
    getNthUserInfo() {
      this.$toast.loading({
        duration: 0,
        message: "加载中...",
      });
      SmartCity.getUserInfo((res) => {
        if (res && res.userInfo) {
          this.$toast.clear();
          this.setNthUserInfo(res.userInfo);
        } else {
          this.$toast.clear();
          this.$dialog
            .alert({
              title: "提醒",
              message: "请先登录南太湖号",
            })
            .then(() => {
              SmartCity.goLogin();
            });
        }
      });
    },
    setNthUserInfo(userInfo) {
      this.$store.commit("setNthUserInfo", userInfo);
      console.log("nthToken", userInfo.userTokenKey);
      this.userAccess();
      // this.onLogin(userInfo);
    },
    getUserInfo(SmartCity) {
      SmartCity.getUserInfo((res) => {
        if (res && res.userInfo) {
          let userInfo = res.userInfo || {};
          let userTokenKey = userInfo.userTokenKey || "";
          setLocalStorage("userTokenKey", userTokenKey);
          // this.getLogin(userTokenKey);
        } else {
          SmartCity.goLogin();
        }
      });
    },
    switchTab(index) {
      this.searchText = "";
      this.targetTab = index;
    },
    //跳转详情
    onItemClick(item) {
      this.$router.push({
        path: "/Detail",
        query: {
          id: item.id,
          ifAssisted: this.returnIfAssisted(item.id),
          activeTab: this.typeList[this.activeTab],
          // item: JSON.stringify({
          //   ...item,
          // }),
        },
      });
    },
    onCheckChange(e, item) {
      if (!this.isSmartCityApp && !this.openId) {
        window.location.href = this.jumpUrl;
      }
      console.log(e);
      if (e && this.votedNum > this.limitNum) {
        item.checked = false;
        this.$toast.fail("已达到选择数量上限");
      }
      // this.selectedList.push(e);
    },
    getImgCode() {
      axios({
        method: "post",
        headers: {
          // token: "8c8d7ef25e25fdf8e30cbb617b271a98",
          token: this.$store.state.nthUserInfo.userTokenKey,
        },
        url: "https://server.zhijianmedia.cn/childVote/home/getImgCode",
        responseType: "arraybuffer",
      }).then((res) => {
        this.codeUrl =
          "data:image/png;base64," +
          btoa(
            new Uint8Array(res.data).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ""
            )
          );
      });
    },
    beforeClose(action, done) {
      console.log(action);
      if (action === "cancel") {
        return done(true);
      } else {
        this.vote(action, done);
      }
    },
    vote(action, done) {
      if (this.scrollTop < 1000) {
        return;
      }
      if (this.assistedList && this.assistedList.length > 0) {
        return;
      }
      let resList = [];
      this.list.map((item) => {
        if (item.checked) {
          resList.push(item.id);
        }
      });
      if (resList.length !== this.limitNum) {
        this.$toast.fail(`请选择${this.limitNum}位候选人`);
        return;
      }
      if (this.isSmartCityApp) {
        this.nthVote(resList);
      } else {
        this.nthVote(resList);
        // this.programVote(resList);
      }
    },
    onUpdateCode() {
      this.getImgCode();
    },
    //浏览节目
    async getWorksList() {
      let params = {
        ...this.pageData,
        type: this.activeTab + 1,
      };
      const { data: res } = await getWorksList(params);
      if (res.code != 200) {
        return this.$toast(res.mes);
      } else {
        // debugger
        // 数据全部加载完成
        if (!res.data.nextPage) {
          this.finished = true;
        } else {
          this.pageData.page += 1;
        }
        this.list.push(...res.data.list);
        console.log(this.list);
        // 加载状态结束
        this.loading = false;
      }
    },
    async getVoteRankList() {
      const { data: res } = await getVoteRankList({ ...this.rankListPageData });
      if (res.code != 200) {
        return this.$toast(res.mes);
      } else {
        // if (this.rankListPageData.page === 1) {
        //   this.rankList = res.data.list;
        // } else {
        //   this.rankList.push(...res.data.list);
        // }
        let resData = res.data || {};
        this.rankList = resData;
        // 数据全部加载完成
        if (!res.data.nextPage) {
          this.rankFinished = true;
        } else {
          this.rankListPageData.page += 1;
        }
        // this.rankList = res.data.list;
        // 加载状态结束
        this.rankLoading = false;
      }
    },
    goApp() {
      window.location.href =
        "http://share.plus.hugd.com/app/jump/2022/xinghaibei";
    },
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      if (this.pageFlag) {
        this.searchProgram();
      } else {
        this.getWorksList();
      }
    },
    onLoadRank() {
      this.getVoteRankList();
    },
    async getMainData() {
      let res = await getMainData();
      let resData = res.data || {};
      if (resData.code === 200) {
        this.mainData = resData.data || {};
      }
    },
    toVote(id) {
      if (SmartCity.isSmartCityApp()) {
        this.targetId = id;
        // this.getImgCode();
        // this.showDialog = true;
        this.vote();
      } else {
        this.goApp();
      }
    },
    //用户访问
    async userAccess() {
      const { data: res } = await userAccess();
      if (res.code != 200) {
        return this.$toast(res.mes);
      } else {
        this.getAssistedPrograms();
        return;
      }
    },
    //用户访问
    async wxUserAccess() {
      const { data: res } = await wxUserAccess();
      if (res.code != 200) {
        return this.$toast(res.mes);
      } else {
        this.getWxAssistedPrograms();
        return;
      }
    },
    //搜索节目
    async searchProgram(ifFirst) {
      if (this.searchText === "") {
        this.pageData.page = 1;
        this.pageFlag = 0;
        this.list = [];
        this.finished = false;
        // this.getWorksList();
        return;
      }
      this.pageFlag = 1;
      if (ifFirst) {
        this.pageData.page = 1;
      }
      const { data: res } = await searchProgram({
        ...this.pageData,
        searchText: this.searchText,
        type: this.activeTab + 1,
      });
      if (res.code != 200) {
        return this.$toast(res.mes);
      } else {
        // 数据全部加载完成
        if (!res.data.nextPage) {
          this.finished = true;
        } else {
          this.pageData.page += 1;
        }
        if (ifFirst) {
          this.list = res.data.list;
        } else {
          this.list.push(...res.data.list);
        }
        this.targetTab = 0;
        // 加载状态结束
        this.loading = false;
      }
    },
    //获取用户当日已投票节目id列表
    async getAssistedPrograms() {
      const { data: res } = await getAssistedPrograms();
      if (res.code != 200) {
        return this.$toast(res.mes);
      } else {
        this.assistedList = res.data || [];
        console.log(this.assistedList);
      }
    },
    //获取用户当日已投票节目id列表
    async getWxAssistedPrograms() {
      let params = { openId: this.openId };
      const { data: res } = await getWxAssistedPrograms(params);
      if (res.code != 200) {
        return this.$toast(res.mes);
      } else {
        this.assistedList = res.data || [];
        // console.log(this.assistedList);
        if (this.assistedList.length > 0) {
          Dialog.confirm({
            title: "微信已投票",
            message: "您可前往南太湖号客户端继续投票",
            className: "myDialog",
          })
            .then(() => {
              // on confirm
              window.location.href = this.jumpUrl;
            })
            .catch(() => {
              // on cancel
            });
        }
      }
    },
    //投票数
    async getVoteNum() {
      const { data: res } = await getVoteNum();
      if (res.code != 200) {
        return this.$toast(res.mes);
      } else {
        for (const i in this.list) {
          res.data.map((item) => {
            if (this.list[i].id === item.id) {
              this.list[i].voteNum = item.voteNum;
            }
          });
        }
      }
    },
    returnIfAssisted(id) {
      let resFlag = this.assistedList.indexOf(id);
      if (resFlag === -1) {
        return false;
      } else {
        return true;
      }
    },
    returnTypeStr(type) {
      return this.typeList[+type - 1];
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let offsetTop = document.querySelector(".topBarContainer").offsetTop;
      if (offsetTop !== null && scrollTop) {
        this.scrollTop = +scrollTop;
        console.log("scrollTop" + scrollTop);
        // 通过opacity
        // let opacity = this.scrollTop / 140;
        // opacity = opacity > 1 ? 1 : opacity;
        // if (this.scrollTop > 20) {
        //   this.opacityStyle = { opacity };
        // } else {
        //   this.opacityStyle = { opacity: 0 };
        // }
      }
      if (scrollTop == 0) {
        this.scrollTop = 0;
      }
    },

    //微信
    getCode() {
      const local = window.location.href;
      const code = this.getQueryStringWX("code");
      this.code = code;
      console.log("code=========================" + code);
      if (!code) {
        console.log(this.appId);
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${
          this.appId
        }&redirect_uri=${encodeURIComponent(
          "https://prod-app-frontend.zhijianmedia.cn/piano-vote/#/Vote"
        )}&response_type=code&scope=snsapi_base&state=123#wechat_redirect`;
      } else {
        this.getOpenId();
      }
    },
    async getOpenId() {
      console.log("========================>getOpenId");
      let params = { code: this.code };
      let res = await getOpenId(params);
      let resData = res.data;
      console.log(resData);
      if (resData.code === 200) {
        this.openId = resData.data.openId;
        setLocalStorage("wxOpenId", this.openId);
        this.wxUserAccess();
      }
    },

    getQueryStringWX(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg); //获取url中"?"符后的字符串并正则匹配
      var context = "";
      if (r != null) context = r[2];
      reg = null;
      r = null;
      return context == null || context == "" || context == "undefined"
        ? ""
        : context;
    },
    //微信端投票
    async programVote(selectedList) {
      let data = {
        programIds: selectedList,
        openId: this.openId,
      };
      const { data: res } = await programVote(data);
      if (res.code == 200) {
        this.result = [];
        this.code = "";
        this.rankListPageData.page = 1;
        this.getVoteNum();
        this.getVoteRankList();
        this.getMainData();
        this.getWxAssistedPrograms();
        Dialog.confirm({
          title: "微信已投票",
          message: "您可前往南太湖号客户端继续投票",
          className: "myDialog",
        })
          .then(() => {
            // on confirm
            window.location.href = this.jumpUrl;
          })
          .catch(() => {
            // on cancel
          });
      } else {
        this.code = "";
        return this.$toast.fail(res.mes);
      }
    },
    //南太湖端投票
    async nthVote(selectedList) {
      const { data: res } = await worksVote({
        programIds: selectedList.join(","),
      });

      if (res.code == 200) {
        // done(true);
        this.result = [];
        this.code = "";
        this.$toast.success("今日投票成功！");
        // this.pageData.page = 1;
        this.rankListPageData.page = 1;
        this.getVoteNum();
        // this.onLoad();
        // this.getWorksList();
        this.getVoteRankList();
        this.getMainData();
        this.getAssistedPrograms();
      } else {
        // done(true);
        this.code = "";
        return this.$toast.fail(res.mes);
      }
    },
    jumpTo() {
      SmartCity.hideTopView({
        isShow: 1,
      });
      window.location.href =
        "https://fkwcd.cn/v/2lg4qZfj/?slv=4&sid=a5c1&v=oosnVwh2QOgFIA0vbRg3ni00n3aA&from=singlemessage";
    },
  },
  created() {
    SmartCity.hideTopView({
      isShow: 0,
    });
    if (SmartCity.isSmartCityApp()) {
      this.getNthUserInfo();
    } else {
    }
    this.isSmartCityApp = SmartCity.isSmartCityApp();
    // this.getWorksList();
    window.addEventListener("scroll", this.handleScroll);
    if (process.env.NODE_ENV === "development") {
      this.isSmartCityApp = true;
    }
  },
  mounted() {
    var u = navigator.userAgent;
    var ua = u.toLowerCase();
    if (/iphone|ipad|ipod/.test(ua)) {
      this.isIos = true;
    } else {
    }
  },
  activated() {
    if (SmartCity.isSmartCityApp()) {
      setTimeout(() => {
        this.getNthUserInfo();
      }, 1000);
      this.getMainData();
      this.getVoteNum();
      this.rankListPageData.page = 1;
      this.getVoteRankList();
    } else {
      this.getMainData();
      this.getVoteRankList();
    }
  },
  computed: {
    votedNum() {
      let resNum = 0;
      this.list.map((item) => {
        if (item.checked) {
          resNum += 1;
        }
      });
      setItem("votedlist", this.list);
      setItem("votedNum", resNum);
      return resNum;
    },
  },
  watch: {
    activeTab() {
      this.searchText = "";
      this.pageData.page = 1;
      this.pageFlag = 0;
      this.list = [];
      this.finished = false;
    },
  },
};
</script>

<style lang="less" scoped>
@mainColor: #ff7e00;
@mainBgColor: #b4251e;
.mt-10 {
  margin-top: 10px;
}
.mt-20 {
  margin-top: 20px;
}
.mainContainer {
  font-family: PingFang;
  width: 100%;
  min-height: 100vh;
  background: @mainBgColor;
  position: relative;
  padding-bottom: 100px;
  .topBg {
    width: 100vw;
    height: 230px;
    background: @mainBgColor url("../assets/topBg.jpeg") center top no-repeat;
    background-size: cover;
  }
  .mainContent {
    // background: #f08943;
    padding: 10px;
  }
}
.topInfoBox {
  background: #ffffff;
  padding: 11px 0 13px;
  border-radius: 5px;
  .topInfo {
    width: 33%;
    text-align: center;
    padding: 4px 25px 0;
    > div:first-child {
      font-size: 18px;
      font-weight: bold;
      color: @mainColor;
      line-height: 18px;
      margin-bottom: 14px;
    }
    > div:last-child {
      font-size: 10px;
      font-family: SourceHanSansCN;
      font-weight: 400;
      color: #909090;
    }
  }
  .topInfo:nth-child(2) {
    border-left: 1px solid @mainColor;
    border-right: 1px solid @mainColor;
  }
}
.programList {
  padding: 14px 0 0;
  background: @mainBgColor;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}
.ruleContent {
  background: #ffffff;
  border-radius: 10px;
  padding: 20px;
  margin: -62px 10px 0;
  .introText {
    text-indent: 2em;
    text-align: justify;
  }
  .ruleTitle {
    text-align: center;
    font-size: 15px;
    font-weight: bold;
    color: @mainColor;
    // margin: 15px 0 0;
  }
  .ruleDetail {
    font-size: 13px;
    font-weight: normal;
    color: #252525;
    font-family: FZLTHK;
    line-height: 24px;
    span {
      font-weight: bold;
    }
  }
  .ruleTitleText {
    font-weight: bold;
    margin-top: 5px;
  }
}
.programTabs {
  width: 355px;
  height: 34px;
  // border: 1px solid @mainColor;
  border-radius: 15px;
  margin: 28px 0;
  // margin-top: 28px;
  overflow: hidden;
  background: #fff;
  > div {
    font-size: 15px;
    font-weight: bold;
    color: #313131;
    line-height: 34px;
    width: 50%;
    text-align: center;
    color: @mainColor;
  }
  > .actTab {
    color: #fff;
    background: @mainColor;
  }
}
.list {
  .van-checkbox-group {
    width: 100%;
    display: flex;
    flex-wrap: wrap;

    justify-content: space-between;
  }

  .item {
    width: 169px;
    // height: calc(119px + 90px);
    position: relative;
    margin-bottom: 10px;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    overflow: hidden;

    // border: 1px solid @main;
    .img-wrap {
      width: 167px;
      height: 250px;
      background: #fff;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .info {
      width: calc(185px - 18px);
      font-size: 12px;
      font-weight: normal;
      color: #333;
      background: #fff;
      padding: 8px 9px 8px 9px;
      border-bottom-left-radius: 12px;
      border-bottom-right-radius: 12px;
      .indexContainer {
        height: 24px;
        margin: 0 auto;
        background: @mainColor;
        opacity: 1;
        font-size: 11px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 24px;
        text-align: center;
      }
      .maxHeight1 {
        min-height: 60px;
        .names {
          font-size: 11px;
          font-family: PingFang;
          font-weight: 400;
          color: #000000;
          margin-top: 8px;
          line-height: 1.5em;
        }
      }
      .maxHeight {
        min-height: 40px;
        .checkIcon {
          width: 29px;
          height: 29px;
          position: relative;
        }
        .names {
          font-size: 11px;
          font-family: PingFang;
          font-weight: 400;
          color: #000000;
          margin-top: 8px;
          line-height: 1.5em;
        }
      }
      .title {
        font-size: 11px;
        font-family: PingFang;
        font-weight: bold;
        color: #333333;
        line-height: 1.25em;
      }
      .name {
        margin-top: 10px;
        font-size: 12px;
        font-weight: normal;
        color: #333;
      }
      .fromGroup {
        height: 30px;
        line-height: 1.25em;
      }
      .intr {
        font-size: 12px;
      }
    }
    .votes {
      right: 7%;
      bottom: 7%;
      position: absolute;
      z-index: 100;
    }
    .van-checkbox {
      bottom: 7%;
      left: 7%;
      position: absolute;
      z-index: 100;
    }
  }
  .pos {
    height: 100px;
  }
}
.helpBtn {
  width: 58px;
  height: 27px;
  background: @mainColor;
  border-radius: 14px;
  opacity: 1;
  text-align: center;

  font-size: 14px;
  font-weight: bold;
  color: #ffffff;
  line-height: 27px;
}
.assistedBtn {
  .submitBtn {
    background: #c7c6c4 !important;
  }
}
.indexFlag {
  position: absolute;
  top: -2px;
  left: 15px;
  width: 24px;
  height: 24px;
  background: url("../assets/childrenVoting/icon-flag.png") center center
    no-repeat;
  filter: hue-rotate(338deg);
  background-size: contain;
  text-align: center;
  padding-top: 5px;

  font-size: 13px;
  font-weight: normal;
  color: #ffffff;
}
.newIndexFlag {
  position: absolute;
  top: 0;
  left: 0;
  width: calc(88px - 15px);
  height: 30px;
  background: @mainColor;
  // background: linear-gradient(89deg, #ff4d28 0%, #ff9d19 100%);
  border-bottom-right-radius: 35px;
  font-size: 13px;
  font-family: FZLTHK;
  font-weight: normal;
  color: #ffffff;
  line-height: 30px;
  padding-left: 16px;
}
.searchContent {
  position: relative;
  margin-bottom: 24px;
  input {
    width: 261px;
    height: 30px;
    background: #fff;
    padding: 9px 5px 9px 40px;
    border-radius: 15px;
    font-size: 13px;
    font-weight: 400;
    color: #808080;
  }
  .searchBtn {
    width: 52px;
    height: 25px;
    background: @mainColor;
    border-radius: 10px;
    text-align: center;
    line-height: 25px;

    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
  }
  .searchIcon {
    position: absolute;
    left: 13px;
    top: 7px;
    width: 17px;
    height: 18px;
    background: url("../assets/childrenVoting/icon-search.png") center center
      no-repeat;
    background-size: contain;
  }
}
.rankList {
  .typeBar {
    width: 340px;
    height: 26px;
    background: @mainColor;
    border-radius: 5px;
    margin: 18px auto 3px;
    position: relative;

    text-align: center;
    font-size: 15px;
    font-family: FZLTCHJW;
    font-weight: normal;
    color: #ffffff;
    line-height: 26px;
  }
  .typeBar::before {
    width: 5px;
    height: 5px;
    background: #ffffff;
    border-radius: 50%;
    content: "";
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
  }
  .typeBar::after {
    width: 5px;
    height: 5px;
    background: #ffffff;
    border-radius: 50%;
    content: "";
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
  }
  // .rankItem:nth-child(-n + 3) {
  .rankItem:nth-child(1) {
    .rankIndexFlag {
      background: url("../assets/childrenVoting/rankIndex-img.png") center
        center no-repeat;
      background-size: contain;
      color: transparent;
    }
  }
  .rankItem:nth-child(2) {
    .rankIndexFlag {
      background: url("../assets/childrenVoting/rankIndex-img2.png") center
        center no-repeat;
      background-size: contain;
      color: transparent;
    }
  }
  .rankItem:nth-child(3) {
    .rankIndexFlag {
      background: url("../assets/childrenVoting/rankIndex-img3.png") center
        center no-repeat;
      background-size: contain;
      color: transparent;
    }
  }
  .rankItem {
    padding: 9px 0 9px 9px;
    min-height: calc(50px - 22px);
    margin-bottom: 2px;
    .rankIndexFlag {
      color: @mainColor;
      width: 22px;
      line-height: 1.25em;
      // height: 30px;
      // line-height: 30px;
      text-align: center;
      // padding-top: 5px;
      margin-right: 5px;
    }
    .voteNum {
      font-size: 14px;
      font-weight: normal;
      color: @mainColor;
      width: 20%;
      text-align: center;
    }
    .rankItemTitle {
      font-size: 14px;
      width: 70%;
      line-height: 1.25em;
    }
    .number {
      width: 16%;
    }
  }
  .rankItem:nth-child(even) {
    background: #fff;
  }
  .rankItem:nth-child(odd) {
    background: #f3f3f3;
    // background: #fde8da;
  }
}
.selectedContainer {
  font-size: 11px;
  font-family: FZLTHK;
  font-weight: normal;
  color: #ffffff;
  line-height: 32px;
  position: absolute;
  right: 21px;
}
.showBtn {
  opacity: 1 !important;
}
.submitBtn {
  width: 353px;
  height: 39px;
  background: @mainColor;
  border-radius: 20px;
  // position: relative;
  // margin: 0 auto;

  position: fixed;
  z-index: 999;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  transition: all 0.5s;
  opacity: 0;
  .voteText {
    font-size: 18px;
    font-family: FZLTCHJW;
    font-weight: normal;
    color: #ffffff;
    line-height: 39px;
    // margin-right: 84px;
    text-align: center;
  }
}
.assistedBtn {
  background: #c7c6c4;
}
.addBtn {
  width: 56px;
  height: 56px;
  line-height: 0;
  background: url("https://oss2upload.zhijianmedia.cn/common/0_2022082516505076682555326.png")
    center center no-repeat;
  background-size: contain;
  position: fixed;
  right: 19px;
  bottom: 100px;
  border-radius: 50%;
  box-shadow: 0px 0px 5px @mainColor;
  z-index: 120;
}
</style>
<style lang="less">
.van-tab__text {
  font-weight: bold;
}
.myDialog {
  .van-dialog__header {
    font-size: 22px;
    font-weight: bold;
    color: #ff4e27;
    margin: 10px 0;
  }
}
</style>